module.exports = "<app-dashboard-providers></app-dashboard-providers>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/dashboard-providers-external/prov-dashboard/prov-dashboard.component.html
// module id = 2429
// module chunks = 66